import { Text } from "@/atoms"

import styles from "../TakenActions.module.scss"

import type { ComponentType } from "react"

type Props = {
  Icon: ComponentType<{ className?: string }>
  count: number
  onClick: () => void
}

export const ActionIndicator = ({ Icon, count, onClick }: Props) => (
  <button type="button" className={styles.indicator} onClick={onClick}>
    <Icon className={styles.indicatorIcon} />
    <Text className={styles.indicatorCount}>{count}</Text>
  </button>
)
